import { isEmpty } from 'lodash';
import { armsErrorSend } from './libs/armsErrorSend';

/** 获取url query */
export const getQuery = (key: string) => {
  try {
    return new URLSearchParams(window.location.search).get(key);
  } catch (err) {
    console.error(err);
    return undefined;
  }
};

/**
 * 添加search参数，value会转为String，如果value为空则不会添加到链接中
 * @return https://example.com?key=value
 */
export const addSearchParam = ({
  url,
  param,
  value,
  params = {},
}: {
  url: string;
  param?: string;
  value?: string;
  params?: Record<string, unknown>;
}) => {
  try {
    const urlObj = new URL(url);
    param && value && urlObj.searchParams.append(param, String(value));

    if (!isEmpty(params)) {
      Object.keys(params).forEach((key) => {
        params[key] && urlObj.searchParams.append(key, String(params[key]));
      });
    }

    return urlObj.toString();
  } catch (error) {
    armsErrorSend(error as Error, { filename: 'utils/url/addSearchParam', data: { url, param, value } });
    return url;
  }
};

// 使用url / qs.stringify都会造成字符串编码转译，因此单独写一个把对象转为search拼接的方法
const stringifySearchParams = (obj: Record<string, string>) => {
  return Object.keys(obj)
    .map((key) => `${key}=${obj[key]}`)
    .join('&');
};

/**
 * 添加search参数，value会转为String，如果value为空则不会添加到链接中，不会被url编码
 * @return https://example.com?key=value
 */
export const addSearchParamsWithoutEncode = ({
  url,
  param,
  value,
  params = {},
}: {
  url: string;
  param?: string;
  value?: string;
  params?: Record<string, string>;
}) => {
  try {
    const urlObj: Record<string, string> = {};
    if (param && value) urlObj[param] = String(value);

    if (!isEmpty(params)) {
      // 会转化成
      Object.keys(params).forEach((key) => {
        if (params[key]) urlObj[key] = String(params[key]);
      });
    }
    return `${url}${isEmpty(urlObj) ? '' : '?'}${stringifySearchParams(urlObj)}`;
  } catch (error) {
    armsErrorSend(error as Error, { filename: 'utils/url/addSearchParam', data: { url, param, value } });
    return url;
  }
};
